//@ts-nocheck
import axios from "axios";
import i18n from "i18n";
import { API_URL } from "constants/constants";
import { getCookieFromBrowser, removeCookie } from "utils/session";
import { error as toastError } from "components/alert/toast";

const request = axios.create({
  baseURL: API_URL,
  timeout: 16000,
});

request.interceptors.request.use(
  (config) => {
    const token = getCookieFromBrowser("access_token");
    const locale = i18n.language;
    if (token) {
      config.headers.Authorization = token;
    }
    config.params = { lang: locale, ...config.params };
    return config;
  },

  (error) => errorHandler(error),
);

function errorHandler(error) {
  if (error?.response) {
    const errorResponse = error.response?.data ?? error;
    let errorMessage = errorResponse?.message;
    if (errorResponse?.params) {
      errorMessage = Object.values(
        errorResponse.params as Record<string, string[]>,
      )?.[0]?.[0];
    }
    if (error?.response?.status === 401) {
      toastError(i18n.t("unauthorized"), {
        toastId: "unauthorized",
      });
      removeCookie("user");
      removeCookie("access_token");
      if (window && window.location.pathname !== "/") {
        window.location.replace("/");
      }
    }
    throw new Error(errorMessage);
  }

  return Promise.reject(error.response);
}

request.interceptors.response.use((response) => response.data, errorHandler);

export default request;
